
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/how-we-work",
      function () {
        return require("private-next-pages/faq/how-we-work.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/how-we-work"])
      });
    }
  